import React, { Component, PropTypes } from "react";
import simpleFetch from "../../../../utils/simpleFetch";
import { toast } from "react-toastify";
import { FormattedMessage } from "react-intl";

class InfoButton extends Component {
    constructor(props) {
        super(props);
        this.executeAPIRequest = this.executeAPIRequest.bind(this);
    }

    executeAPIRequest() {
        const { postRequestSuccess, postRequestFailure, inProgressToastMessageId } = this.props;
        const { query, body, options, headers, method, endpoint } = this.props.fetchParameters;

        if(inProgressToastMessageId) {
            toast(<FormattedMessage id={inProgressToastMessageId} />, {
                type: toast.TYPE.INFO,
                autoClose: false,
            });
        }
        simpleFetch(method, endpoint, { query, body, options, headers })
            .then(() => {
                toast.dismiss();
                postRequestSuccess();
            })
            .catch((e) => {
                toast.dismiss();
                postRequestFailure(e);
            });
    }

    render() {
        return (
            <span className="info-btn">
                <span onClick={this.executeAPIRequest} className="icon-info clickable-span" />
            </span>
        );
    }
}

InfoButton.propTypes = {
    fetchParameters: PropTypes.object,
    postRequestSuccess: PropTypes.func.isRequired,
    postRequestFailure: PropTypes.func.isRequired,
    inProgressToastMessageId: PropTypes.string
};

export default InfoButton;



// WEBPACK FOOTER //
// ./src/components/common/InfoButton/InfoButton.js